<ac-icon-button [matMenuTriggerFor]="menu" label="{{ 'HEADER.FAQ_BUTTON' | translate }}" primary_negative>
  <ac-icon name="faq" size="small" />
</ac-icon-button>

<mat-menu #menu="matMenu" xPosition="before" class="!max-w-none !rounded-none border border-solid border-neutral-black">
  <ac-help />
</mat-menu>
